import { render, staticRenderFns } from "./MspAccess.vue?vue&type=template&id=2af94b9a&scoped=true&"
import script from "./MspAccess.vue?vue&type=script&lang=js&"
export * from "./MspAccess.vue?vue&type=script&lang=js&"
import style0 from "./MspAccess.vue?vue&type=style&index=0&id=2af94b9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af94b9a",
  null
  
)

export default component.exports